import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-details.svg";
import * as styles from "./Icon.module.scss";

type DetailsProps = React.SVGProps<SVGSVGElement>;

export const Details = ({ className, ...props }: DetailsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
